import { Routes } from '@angular/router';
import { IsAuthenticated } from "./core/auth/auth.guard";
import { PermissionGuard } from './core/guards/permission.guard';
import { PERMISSIONS } from './core/constants/permissions.constant';

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/dashboard',
    pathMatch: 'full'
  },
  {
    path: 'dashboard',
    loadComponent: () => import('./project-modules/dashboard/dashboard.component').then(m => m.DashboardComponent),
    canActivate: [IsAuthenticated]
  },
  {
    path: 'contacts',
    loadComponent: () => import('./project-modules/contacts/list/list.component').then(m => m.ContactsComponent),
    canActivate: [IsAuthenticated, PermissionGuard],
    data: { permissions: [PERMISSIONS.CONTACTS_LIST] }
  },
  {
    path: 'contacts/:id',
    loadComponent: () => import('./project-modules/contacts/view/view.component').then(m => m.CandidateProfileComponent),
    canActivate: [IsAuthenticated, PermissionGuard],
    data: { permissions: [PERMISSIONS.CONTACTS_VIEW] }
  },
  {
    path: 'companies',
    loadComponent: () => import('./project-modules/companies/list/list.component').then(m => m.CompaniesComponent),
    canActivate: [IsAuthenticated, PermissionGuard],
    data: { permissions: [PERMISSIONS.COMPANIES_LIST] }
  },
  {
    path: 'companies/:id',
    loadComponent: () => import('./project-modules/companies/view/view.component').then(m => m.CompanyProfileComponent),
    canActivate: [IsAuthenticated, PermissionGuard],
    data: { permissions: [PERMISSIONS.COMPANIES_VIEW] }
  },
  {
    path: 'projects',
    loadChildren: () => import('./project-modules/project/project.routes').then(m => m.projectRoutes),
    canActivate: [IsAuthenticated, PermissionGuard],
    data: { permissions: [PERMISSIONS.PROJECTS_LIST] }
  },
  {
    path: 'project-settings',
    loadChildren: () => import('./system-modules/settings/settings.routes').then(m => m.SETTINGS_ROUTES),
    canActivate: [IsAuthenticated]
  },
  {
    path: 'my-commissions',
    loadComponent: () => import('./project-modules/commissions/commissions.component').then(m => m.CommissionsComponent),
    canActivate: [IsAuthenticated]
  },
  {
    path: 'tasks',
    loadComponent: () => import('./project-modules/tasks-page/tasks-page').then(m => m.TasksPage),
    canActivate: [IsAuthenticated]
  },
  {
    path: 'notifications',
    loadComponent: () => import('./project-modules/notifications/notifications.component').then(m => m.NotificationsComponent),
    canActivate: [IsAuthenticated]
  },
  {
    path: 'account',
    loadChildren: () => import('./system-modules/account/account.routes').then(m => m.accountRoutes)
  },

  {
    path: 'pipeline',
    loadComponent: () => import('./project-modules/pipeline/pages/pipeline/pipeline.component').then(m => m.PipelineComponent),
    canActivate: [IsAuthenticated, PermissionGuard],
    data: { permissions: [PERMISSIONS.PIPELINE_VIEW] }
  },

  {
    path: 'pipeline/:id',
    loadComponent: () => import('./project-modules/pipeline/pages/pipeline-profile/pipeline-profile.component').then(m => m.PipelineProfileComponent),
    canActivate: [IsAuthenticated, PermissionGuard],
    data: { permissions: [PERMISSIONS.PIPELINE_VIEW] }
  },

  {
    path: 'bd-lists',
    loadChildren: () => import('./project-modules/pipeline/bd-list.routes').then(m => m.bdListRoutes),
    canActivate: [IsAuthenticated, PermissionGuard],
    data: { permissions: [PERMISSIONS.PROJECTS_BD_LIST_ACCESS] }
  },

   {
    path: 'pre-pipeline',
    loadComponent: () => import('./project-modules/pipeline/pages/pre-pipeline/pre-pipeline.component').then(m => m.PrePipelineComponent),
    canActivate: [IsAuthenticated, PermissionGuard],
    data: { permissions: [PERMISSIONS.PRE_PIPELINE_VIEW] }
  },

  {
    path: 'pre-pipeline/:id',
    loadComponent: () => import('./project-modules/pipeline/pages/pre-pipeline-profile/pre-pipeline-profile.component').then(m => m.PrePipelineProfileComponent),
    canActivate: [IsAuthenticated, PermissionGuard],
    data: { permissions: [PERMISSIONS.PRE_PIPELINE_VIEW] }
  },

  {
    path: '**',
    redirectTo: '/dashboard'
  }
];
